import React, { useState, useEffect } from 'react';
import { Table, message, Card, Tag, Button } from 'antd';
import { EyeOutlined, TruckOutlined } from '@ant-design/icons';
import { dropshipperAPI, exchangeRateAPI } from '../api';
import FreightDetailsModal from './Utils/FreightDetailsModal';
import { BRAND_PRIMARY } from '../utils/brandColors';

const ViewFreight = () => {
  const [freightChannels, setFreightChannels] = useState([]);
  const [loading, setLoading] = useState(false);
  const [detailModalVisible, setDetailModalVisible] = useState(false);
  const [selectedFreight, setSelectedFreight] = useState(null);
  const [exchangeRates, setExchangeRates] = useState({});

  useEffect(() => {
    fetchFreightChannels();
    fetchExchangeRates();
  }, []);

  const fetchExchangeRates = async () => {
    try {
      const response = await exchangeRateAPI.getAll();
      const rates = {};
      response.data.forEach(rate => {
        rates[rate.currency_code] = rate.rate_to_usd;
      });
      setExchangeRates(rates);
    } catch (error) {
      
    }
  };

  const fetchFreightChannels = async () => {
    try {
      setLoading(true);
      const response = await dropshipperAPI.getFreightChannels();
      // 按创建时间降序排序，最晚创建的排在最上面
      const sortedChannels = response.data.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
      setFreightChannels(sortedChannels);
    } catch (error) {
      message.error('Failed to fetch freight channels');
    } finally {
      setLoading(false);
    }
  };

  const handleViewDetails = (record) => {
    setSelectedFreight(record);
    setDetailModalVisible(true);
  };

  const formatDestinations = (data) => {
    if (!data || typeof data !== 'object') return '-';
    const destinations = Object.keys(data);
    if (destinations.length === 0) return '-';
    if (destinations.length <= 3) {
      return destinations.join(', ');
    }
    return `${destinations.slice(0, 3).join(', ')} and ${destinations.length - 3} more regions`;
  };


  const columns = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      width: '8%',
    },
    {
      title: 'Channel Name',
      dataIndex: 'name',
      key: 'name',
      width: '25%',
      ellipsis: true,
      render: (text) => (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <TruckOutlined style={{ marginRight: 8, color: BRAND_PRIMARY }} />
          <strong>{text}</strong>
        </div>
      ),
    },
    {
      title: 'Coverage Areas',
      dataIndex: 'data',
      key: 'destinations',
      render: (data) => (
        <div>
          <div>{formatDestinations(data)}</div>
          {data && Object.keys(data).length > 0 && (
            <Tag color={BRAND_PRIMARY} style={{ marginTop: 4 }}>
              {Object.keys(data).length} regions
            </Tag>
          )}
        </div>
      ),
      ellipsis: true,
    },
    {
      title: 'Created',
      dataIndex: 'created_at',
      key: 'created_at',
      render: (date) => new Date(date).toLocaleDateString('en-US'),
      width: '15%',
    },
    {
      title: 'Updated',
      dataIndex: 'updated_at',
      key: 'updated_at',
      render: (date) => new Date(date).toLocaleDateString('en-US'),
      width: '15%',
    },
    {
      title: 'Actions',
      key: 'action',
      width: '17%',
      render: (_, record) => (
        <Button
          type="primary"
          size="small"
          icon={<EyeOutlined />}
          onClick={() => handleViewDetails(record)}
        >
          View Details
        </Button>
      ),
    },
  ];

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: 24 }}>
        <TruckOutlined style={{ fontSize: 24, marginRight: 12, color: BRAND_PRIMARY }} />
        <h1 style={{ margin: 0, fontSize: 24, fontWeight: 'bold' }}>
          Freight Channels
        </h1>
      </div>

      <Card>
        <Table
          columns={columns}
          dataSource={freightChannels}
          rowKey="id"
          loading={loading}
          pagination={{
            pageSize: 10,
            showSizeChanger: true,
            showQuickJumper: true,
            showTotal: (total) => `Total ${total} freight channels`,
          }}
          size="middle"
          locale={{
            emptyText: 'No freight channels available'
          }}
        />
      </Card>

      {/* Freight Details Modal */}
      <FreightDetailsModal
        visible={detailModalVisible}
        onCancel={() => {
          setDetailModalVisible(false);
          setSelectedFreight(null);
        }}
        selectedFreight={selectedFreight}
        exchangeRates={exchangeRates}
      />
    </div>
  );
};

export default ViewFreight;
